import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import generateId from './generateId';
import { updateHashProps, rewriteUserId } from '../general';
import { addDatasToSave, loadDbModel } from './workBackendSlice';
import { saveAllData, saveData, deleteData, SignUpPayload } from './dataBackend';

export type CardCodeDb = {
  cardId: string;
  content: string;
}
const initial: CardCodeDb = {
  cardId: '',
  content: ''
};

export type CardCodeDbHashType = {
  [key in string]: CardCodeDb;
}

export type CardCodeAddPayload = {
  id?: string;
} & CardCodeDb;
export type CardCodeUpdatePayload = {
  id: string;
} & { [P in keyof CardCodeDb]?: CardCodeDb[P] };

export type CardCodeDbState = {
  cardCodes: CardCodeDbHashType;
}

export const generateCardCodeId = (): string => generateId('cc');
let initialState: CardCodeDbState = { cardCodes: {} };
const key = 'cardCodes';

const cardCodeDbSlice = createSlice({
  name: 'cardCodeDb',
  initialState,
  reducers: {
    initializeCardCodes(state: CardCodeDbState) {
      state.cardCodes = {};
    },
    addCardCode(state: CardCodeDbState, action: PayloadAction<CardCodeAddPayload>) {
      let { id, ...obj } = action.payload;
      if (!id) id = generateCardCodeId();
      state.cardCodes[id] = obj;
      saveData(key, id, obj);
    },
    updateCardCode(state: CardCodeDbState, action: PayloadAction<CardCodeUpdatePayload>) {
      const { id, ...obj } = action.payload;
      if (state.cardCodes[id] === undefined) {
        console.log(`*** CardCode not found: ${id}`);
      } else {
        const newData = { ...state.cardCodes[id], ...obj };
        state.cardCodes[id] = newData;
        saveData(key, id, newData);
      }
    },
    deleteCardCode(state: CardCodeDbState, action: PayloadAction<CardCodeUpdatePayload>) {
      const id = action.payload.id;
      delete state.cardCodes[id];
      deleteData(key, id);
    },
    saveCardCodes(state: CardCodeDbState, action: PayloadAction<void>) {
      saveAllData(key, state.cardCodes);
    },
    signUpCardCodes(state: CardCodeDbState, action: PayloadAction<SignUpPayload>) {
      const values = rewriteUserId(state.cardCodes, action.payload);
      addDatasToSave(key, values);
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loadDbModel(key).fulfilled, (state: CardCodeDbState, action) => {
      const values = action.payload;
      const [changed, updatedValues] = updateHashProps(initial, values);
      state.cardCodes = updatedValues;
      if (changed) saveAllData(key, state.cardCodes);
    })
  }
})

export const { initializeCardCodes, addCardCode, updateCardCode, deleteCardCode, saveCardCodes, signUpCardCodes } = cardCodeDbSlice.actions;
export default cardCodeDbSlice.reducer;
